"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextCell = void 0;
var react_1 = __importDefault(require("react"));
var shared_styles_1 = require("./shared.styles");
var TextCell = function (_a) {
    var cell = _a.cell;
    return react_1.default.createElement(shared_styles_1.EllipsisText, null, cell.value);
};
exports.TextCell = TextCell;
